import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SearchForm from "components/SearchForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdminThunk } from "store/reducers/accounts";
import {
  assignAdminThunk,
  removeAdminThunk,
} from "store/reducers/machine_func/machineAssignments";

const AssignAdminDialog = ({ open, handleClose, machine_id }) => {
  const [search, setSearch] = React.useState("");
  const dispatch = useDispatch();
  const admins = useSelector((state) => state.accounts.admins);
  const { adminAssignMentLoading, adminRemoveLoading } = useSelector(
    (state) => state.vending
  );

  const machine = useSelector((state) => state.vending.machines).find(
    (item) => item.id === machine_id
  );
  useEffect(() => {
    if (open) {
      dispatch(getAdminThunk());
    }
  }, [dispatch, open]);

  const assignAdmin = (admin) => {
    dispatch(assignAdminThunk({ admin, machine: machine_id }));
  };
  const removeAdmin = (admin) => {
    dispatch(removeAdminThunk({ admin: admin.id, machine: machine_id }));
  };

  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Select admins to add"
    >
      <Box paddingX={2}>
        <SearchForm
          hint="Search admins"
          submitSearch={setSearch}
          sx={{ marginY: 2 }}
        />
      </Box>
      {admins.length > 0 ? (
        <>
          {admins
            .filter((item) => item.profile !== null)
            .map((admin) => (
              <Stack
                justifyContent="space-between"
                margin={2}
                direction="row"
                alignItems="center"
                key={admin.id}
              >
                {machine?.admins?.find(
                  (item) => item.id === admin.profile.id
                ) ? (
                  <>
                    <Box>
                      <Typography variant="body1" color="green">
                        {admin.profile.first_name} {admin.profile.last_name}
                      </Typography>
                      <Typography variant="body2" color="gray">
                        @{admin.username}
                      </Typography>
                    </Box>
                    <LoadingButton
                      variant="outlined"
                      size="small"
                      loading={adminRemoveLoading[admin.profile.id]}
                      onClick={() => removeAdmin(admin.profile)}
                    >
                      Remove
                    </LoadingButton>
                  </>
                ) : (
                  <>
                    <Box>
                      <Typography variant="body1" color="green">
                        {admin.profile.first_name} {admin.profile.last_name}
                      </Typography>
                      <Typography variant="body2" color="gray">
                        @{admin.username}
                      </Typography>
                    </Box>
                    <LoadingButton
                      variant="outlined"
                      size="small"
                      loading={adminAssignMentLoading[admin.profile.id]}
                      onClick={() => assignAdmin(admin.profile)}
                    >
                      Assign
                    </LoadingButton>
                  </>
                )}
              </Stack>
            ))}
        </>
      ) : (
        <Typography textAlign="center"> No items </Typography>
      )}
    </CustomDialog>
  );
};

export default AssignAdminDialog;
